import { render, staticRenderFns } from "./GanghaolaiMall.vue?vue&type=template&id=2663fa30&scoped=true&"
import script from "./GanghaolaiMall.vue?vue&type=script&lang=js&"
export * from "./GanghaolaiMall.vue?vue&type=script&lang=js&"
import style0 from "./GanghaolaiMall.vue?vue&type=style&index=0&id=2663fa30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2663fa30",
  null
  
)

export default component.exports